/* eslint-disable no-unused-vars */

import React from 'react';

import { Button, CardMedia, Grid, Link, Stack, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

import { CustomCarousel } from '../../common_components';
import { StyledChip } from '../../common_components/styled';
import { CalendarIcon } from '../../Icons/CalendarIcon';
import { StyledColumn, StyledNFTDetailsCard, StyledRow, useStyles } from '../styles';

export const NFTSaleDetails = (props) => {
  const {
    launch_sites,
    logo_url,
    total_supply,
    ecosystems,
    presale_mint_price,
    public_mint_price,
    price_unit,
    categories,
    attachments
  } = props;

  const {
    launch_end_date,
    launch_site,
    launch_start_date,
    nft_public_end_date,
    nft_public_start_date,
    site_name,
    twitter_id
  } = launch_sites.length > 0 ? launch_sites[0] : {};
  const nftImages = attachments?.filter((item) => item.attachment_type === 'NFTIMAGES');
  const classes = useStyles();

  const getDate = (date) => {
    return dayjs(date).utc().isValid() ? dayjs(date).format('D MMM, HH:mm') : 'TBA';
  };

  const getCategories = () => {
    const hiddenData = categories?.length > 1 ? categories?.slice(1) : [];
    const dataToBeShown = categories.slice(0, 1);

    if (hiddenData.length > 0) {
      return (
        <>
          <Stack direction="row">
            {dataToBeShown.map((data, index) => (
              <StyledChip
                label={data.category_name}
                fontColor="purple"
                key={index}
                variant="outlined"
                size="small"
              />
            ))}

            <Tooltip title={hiddenData.map((item) => item.category_name).join(' , ')}>
              <StyledChip
                label={`+${hiddenData.length}`}
                variant="outlined"
                fontColor={'#00a152'}
                size="small"
              />
            </Tooltip>
          </Stack>
        </>
      );
    } else {
      return (
        <>
          {dataToBeShown.map((data, index) => (
            <StyledChip
              label={data.category_name}
              fontColor="purple"
              key={index}
              variant="outlined"
              size="small"
            />
          ))}
        </>
      );
    }
  };

  const getSaleDetails = () => {
    return (
      <StyledNFTDetailsCard color={'#ff9900'} sx={{ mb: '25%' }}>
        <Typography variant="h6" noWrap component="div">
          {`Project Details`}
        </Typography>
        <StyledRow>
          <StyledColumn>
            <Typography variant="title2" textAlign="start">
              {`Category`}
            </Typography>
            {categories?.length > 0 ? (
              <Stack direction="row">{getCategories()}</Stack>
            ) : (
              <Typography variant="title1" textAlign="center">
                {`-`}
              </Typography>
            )}
          </StyledColumn>
          <StyledColumn sx={{ alignItems: 'center', flex: 0.75 }}>
            <Typography variant="title2" gutterBottom component="div">
              {`Chain`}
            </Typography>

            <Typography variant="title1" gutterBottom component="div">
              {ecosystems?.[0]?.ecosys_name}
            </Typography>
          </StyledColumn>
        </StyledRow>
        <StyledRow>
          <StyledColumn>
            <Stack direction="row" alignItems="center" gap={1}>
              <CalendarIcon />
              <Typography variant="title2" gutterBottom component="div">
                {`Pre Sale Duration (UTC)`}
              </Typography>
            </Stack>
            {launch_start_date || launch_end_date ? (
              <Typography variant="title1">
                {`${getDate(launch_start_date)} - ${getDate(launch_end_date)}`}
              </Typography>
            ) : (
              <Typography variant="title1" textAlign="center">
                {`-`}
              </Typography>
            )}
          </StyledColumn>
          <StyledColumn sx={{ alignItems: 'center', flex: 0.75 }}>
            <Typography variant="title2" gutterBottom component="div">
              {`Pre-sale Price`}
            </Typography>

            <Typography variant="title1" textAlign="center">
              {presale_mint_price ? `${presale_mint_price} ${price_unit}` : `-`}
            </Typography>
          </StyledColumn>
        </StyledRow>
        <StyledRow sx={{ mt: 1 }}>
          <StyledColumn>
            <Stack direction="row" alignItems="center" gap={1}>
              <CalendarIcon />
              <Typography variant="title2" gutterBottom component="div">
                {`Public Mint Duration (UTC)`}
              </Typography>
            </Stack>
            {nft_public_start_date || nft_public_end_date ? (
              <Typography variant="title1">
                {`${getDate(nft_public_start_date)} - ${getDate(nft_public_end_date)}`}
              </Typography>
            ) : (
              <Typography variant="title1" textAlign="center">
                {`-`}
              </Typography>
            )}
          </StyledColumn>
          <StyledColumn sx={{ alignItems: 'center', flex: 0.75 }}>
            <Typography variant="title2" gutterBottom component="div">
              {`Public-mint Price`}
            </Typography>

            <Typography variant="title1" textAlign="center">
              {public_mint_price ? `${public_mint_price} ${price_unit}` : '-'}
            </Typography>
          </StyledColumn>
        </StyledRow>
        <StyledRow sx={{ mt: 1 }}>
          <StyledColumn alignItems="flex-start">
            <Typography variant="title2" gutterBottom component="div">
              {`Total Supply`}
            </Typography>

            <Typography variant="title1" gutterBottom component="div">
              {total_supply}
            </Typography>
          </StyledColumn>

          <StyledColumn></StyledColumn>
        </StyledRow>

        <Button
          variant="outlined"
          style={{ margin: '0 auto', display: 'flex', width: 200, marginTop: 10 }}
          component={Link}
          target="_blank"
          href={launch_site}>
          Mint
        </Button>
      </StyledNFTDetailsCard>
    );
  };
  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={3} />
      <Grid
        item
        xs={12}
        md={3}
        sx={{ display: 'flex', justifyContent: 'flex-end', direction: 'row' }}>
        <CustomCarousel>
          {nftImages?.length > 0 ? (
            nftImages.map((item, index) => {
              return (
                <div key={index}>
                  <img src={item.logo_url} />
                </div>
              );
            })
          ) : (
            <div>
              <img src={logo_url} />
            </div>
          )}
        </CustomCarousel>
      </Grid>
      <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        {getSaleDetails()}
      </Grid>
    </Grid>
  );
};
